/*
 * Copyright (c) 2023. All rights are reserved to Newport Collection
 */

import theme from 'components/theme';

const mobileStyle = {
	search__mobile: {
		overflow: 'visible !important',
		position: 'relative',
		'& .MuiDrawer-paperAnchorTop': {
			bottom: 0,
			paddingBottom: '0',
			overflowY: 'visible',
			backgroundColor: 'transparent'
		},
		'& .MuiDrawer-paperAnchorRight': {
			overflow: 'visible',
			left: '50px'
		},
		'& .close-right': {
			zIndex: 1000,
			position: 'absolute',
			height: 33,
			width: 33,
			backgroundColor: 'white',
			borderRadius: '50%',
			display: 'block',
			top: '30px',
			left: '-40px',
			margin: '0 auto',
			padding: 5
		},
		[theme.breakpoints.up('md')]: {
			display: 'none',
			maxWidth: '360px'
		}
	},
	search__footer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'fixed',
		bottom: 10,
		zIndex: 2000,
		width: '100%',
		'& .close': {
			height: 40,
			width: 40,
			backgroundColor: 'white',
			borderRadius: '50%',
			display: 'block',
			padding: 10,
			margin: '10px 0',
		}
	}
};

module.exports = mobileStyle;
